import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1 2.597A1.304 1.304 0 0011.992 2c-.394 0-.834.176-1.105.581l-.005.008-1.287 2.028-.003.006a2.56 2.56 0 00-.392 1.36c0 1.827 1.91 3.037 3.721 2.476h.002c.974-.304 1.738-1.147 1.859-2.162v-.002a2.448 2.448 0 00-.409-1.692L13.1 2.597zm-2.152 2.875l1.04-1.64 1.053 1.659.011.015c.112.16.169.36.14.602-.039.332-.317.69-.744.823-.953.294-1.648-.371-1.648-.947a.96.96 0 01.148-.512zM11.2 10.4a.8.8 0 111.6 0v.6H17a3 3 0 013 3v5a3 3 0 01-3 3H7a3 3 0 01-3-3v-5a3 3 0 013-3h4.2v-.6zm5.8 2.2H7A1.4 1.4 0 005.6 14v1.689c0 .307.1.637.273.921.176.29.385.466.538.534.244.104.528.056.762-.257l.006-.007 1.814-2.367a.8.8 0 011.27.002l1.806 2.366c.19.25.392.319.538.319.147 0 .348-.07.539-.319v-.001l1.815-2.367a.8.8 0 011.27.002l1.806 2.366c.12.157.244.245.363.286V14a1.4 1.4 0 00-1.4-1.4zM5.6 18.526c.056.031.114.06.172.085l.004.002c.992.427 2.044.077 2.675-.763l1.175-1.533 1.171 1.535c.454.595 1.105.948 1.81.948.706 0 1.356-.352 1.81-.947v-.001l1.177-1.535 1.171 1.535c.408.534.986.886 1.635.938V19a1.4 1.4 0 01-1.4 1.4H7A1.4 1.4 0 015.6 19v-.474z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
